import React, { useState } from 'react';
import Landing from './pages/Landing';
import Test from './pages/Test';
import EmailCapture from './pages/EmailCapture';
import Results from './pages/Results';
import './App.css';

export default function App() {
  const [page, setPage] = useState('landing');
  const [result, setResult] = useState(null);
  const [email, setEmail] = useState('');

  return (
    <div className="app">
      {page === 'landing' && <Landing onStart={() => setPage('test')} />}
      {page === 'test' && (
        <Test onComplete={(res) => { setResult(res); setPage('capture'); }} />
      )}
      {page === 'capture' && (
        <EmailCapture result={result} onSubmit={(em) => { setEmail(em); setPage('results'); }} />
      )}
      {page === 'results' && <Results result={result} email={email} />}
    </div>
  );
}
